<template>

  <div class="hit-form-group">
    <div class="hit-form-group">
      <a href="#" class="hit-btn hit-btn-default" v-on:click.prevent="show_code()">{{ $t("message.embedCode") }}</a>
    </div>
    <div v-if="show">
      <textarea readonly="true" v-bind:id="id" v-key="id" class="hit-form-control" spellcheck="false" v-on:click.prevent="set_focus">{{ get_embed().split("[").join("<").split("]").join(">") }}</textarea>
    </div>
    <small class="hit-html-small" v-if="show" v-text="$t('message.embedHint')"> </small>

  </div>

</template>

<script>

export default{
  name: 'embedcode',
  props: { code: Object },
  data: function () {
    return {
      id: new Date().getTime(),
      show: false
    }
  },
  methods: {

    show_code: function () {
      this.show = !this.show
    },

    get_embed: function () {
      var embedCode = btoa(JSON.stringify(this.$props.code))
      // var embedCode = JSON.stringify( this.$props.code );

      let html = ''

      html += '[script]'
      html += '(function(a,b,c,d,e,f,g){ f=b.createElement(c);'
      html += 'g=b.currentScript;'
      html += 'f.async=1;f.src=d; g.parentNode.replaceChild(f,g,b);f.onload=function(){hit(f,e);};'
      html += '})(window,document,\'script\',\'https://api.hitklick.com/assets/js/embed.js\',\'' + embedCode + '\');'
      html += '[/script]'

      return html
    },
    set_focus: function () {
      event.target.select()
      event.target.focus()
    }
  }
}

</script>
